import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateMultiHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { authInterceptor } from '../core/interceptors/auth.interceptor';
import { errorInterceptor } from '../core/interceptors/error.interceptor';
import { languageInterceptor } from '../core/interceptors/language.interceptor';
import { loadingInterceptor } from '../core/interceptors/loading.interceptor';
import { successInterceptor } from '../core/interceptors/success.interceptor';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideTranslateService({
      lang: environment.defaultLanguage,
      fallbackLang: 'en',
      loader: provideTranslateMultiHttpLoader({
        resources: [
          { prefix: 'assets/i18n/', suffix: '/common.json' },
          { prefix: 'assets/i18n/', suffix: '/navigation.json' },
          { prefix: 'assets/i18n/', suffix: '/auth.json' },
          { prefix: 'assets/i18n/', suffix: '/application.json' },
          { prefix: 'assets/i18n/', suffix: '/dashboard.json' },
          { prefix: 'assets/i18n/', suffix: '/nominee.json' },
          { prefix: 'assets/i18n/', suffix: '/validation.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/common.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/master-module.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/parameter-master.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/category-master.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/question-master.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/question-form.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/question-section-master.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/question-mapping.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/user-management.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/role-permission.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/location-master.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/application-master.json' },
          { prefix: 'assets/i18n/', suffix: '/settings/cms.json' },
        ],
      }),
    }),
    provideHttpClient(withXhr(), 
      withInterceptors([
        authInterceptor,
        languageInterceptor,
        loadingInterceptor,
        successInterceptor,
        errorInterceptor,
      ]),
    ),
  ],
};
